import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = 'visitor_counted';

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        // Check if this visitor has already been counted in this session
        // const hasVisited = sessionStorage.getItem('visitor_counted');

        const hasVisited = localStorage.getItem(VISITOR_KEY);
        
        if (!hasVisited) {
          localStorage.setItem(VISITOR_KEY, 'pending');

          // Increment visitor count
          const response = await axios.post(`${BACKEND_URL}/api/visitor-count`);
          setVisitorCount(response.data.count);
          // Mark this session as counted
          // sessionStorage.setItem('visitor_counted', 'true');
          localStorage.setItem(VISITOR_KEY, 'true');
        } else {
          // Just get the current count without incrementing
          const response = await axios.get(`${BACKEND_URL}/api/visitor-count`);
          setVisitorCount(response.data.count);
        }
      } catch (error) {
        console.error('Error tracking visitor:', error);
        if (localStorage.getItem(VISITOR_KEY) === 'pending') {
          localStorage.removeItem(VISITOR_KEY);
        }
        // Fallback to just getting count
        try {
          const response = await axios.get(`${BACKEND_URL}/api/visitor-count`);
          setVisitorCount(response.data.count);
        } catch (err) {
          console.error('Error getting visitor count:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    trackVisitor();
  }, []);

  const formatCount = (count) => {
    return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  if (loading) {
    return null;
  }

  return (
    <div className="visitor-counter">
      <div className="visitor-counter-content">
        <Users size={20} className="visitor-icon" />
        <span className="visitor-text">Total Visitors:</span>
        <span className="visitor-count">{formatCount(visitorCount)}</span>
      </div>
    </div>
  );
};

export default VisitorCounter;
